<template>
  <div class="section">
    <div style="padding-left: 20px">
      <div>
        <el-button v-show="readonly" no="Add2" type="primary" @click="editHandler">{{ $t('CargoMsg.Cargo_Edit') }}</el-button>
        <el-button v-show="!readonly" no="save" type="success" @click="saveHandler">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
        <el-button v-show="!readonly" no="cancel" type="primary" @click="cancelHandler">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </div>
      <div style="padding-top: 5px">
        <el-checkbox v-model="from.openAe" no="5" :disabled="readonly">{{ $t('CargoMsg.Cargo_AirExportEnableImperialUnits') }}</el-checkbox>
      </div>

      <el-form label-width="130px" label-position="left" style="height:100%">
        <el-form-item :label="'1 ' + $t('CargoMsg.Cargo_Inch') + '(IN)' + $t('CargoMsg.Cargo_EqualTo')">
          <div style="display: flex">
            <el-input-number
              v-model="from.inch"
              no="inch"
              :min="0"
              :controls="false"
              :max="999999.999"
              :precision="6"
              :disabled="readonly"
              style="width: 200px;padding-right: 5px"
            />
            <span>{{ $t('CargoMsg.Cargo_Centimeter') + '(CM)' }}</span>
          </div>
        </el-form-item>
        <el-form-item :label="'1 ' + $t('CargoMsg.Cargo_CubicFoot') + '(CFT)' + $t('CargoMsg.Cargo_EqualTo')">
          <div style="display: flex">
            <el-input-number
              v-model="from.cubicFoot"
              no="cubicFoot"
              :min="0"
              :max="999999.999"
              :controls="false"
              :disabled="readonly"
              :precision="6"
              style="width: 200px;padding-right: 5px"
            />
            <span>{{ $t('CargoMsg.Cargo_CubicMeter') + '(CBM)' }}</span>
          </div>
        </el-form-item>
        <el-form-item :label="'1 ' + $t('CargoMsg.Cargo_Pound') + '(LB)' + $t('CargoMsg.Cargo_EqualTo')">
          <div style="display: flex">
            <el-input-number
              v-model="from.pound"
              no="pound"
              :min="0"
              :controls="false"
              :max="999999.999"
              :precision="6"
              :disabled="readonly"
              style="width: 200px;padding-right: 5px"
            />
            <span>{{ $t('CargoMsg.Cargo_Kilogram') + '(KG)' }}</span>
          </div>
        </el-form-item>
      </el-form>
    </div>

  </div>
</template>

<script>

import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput.vue'
import { ImperialUnitsSettingQueryFunc, ImperialUnitsSettingSaveFunc } from '@/api/sysManage/ImperialUnitsSetting'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { syncSpecificBasicData } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'

export default {
  name: 'ImperialUnitsSetting',
  components: { AutoNumberInput },
  data() {
    return {
      loading: false,
      action: 'look',
      from: {
        openAe: false,
        inch: 2.54,
        cubicFoot: 0.0283,
        pound: 0.4536
      }
    }
  },
  computed: {
    readonly() {
      return this.action === 'look'
    }
  },
  created() {
    this.queryHandler()
  },
  methods: {
    clear() {
      this.from.openAe = false
      this.from.inch = 0
      this.from.cubicFoot = 0
      this.from.pound = 0
    },
    queryHandler() {
      this.clear()
      this.loading = getLoading4Cxt()
      ImperialUnitsSettingQueryFunc().then(res => {
        if (res.data) {
          const data = res.data
          this.from.openAe = data.openAe
          this.from.inch = data.inch
          this.from.pound = data.pound
          this.from.cubicFoot = data.cubicFoot
        }
        this.loading.close()
      })
    },
    editHandler() {
      this.action = 'edit'
    },
    cancelHandler() {
      this.action = 'look'
      this.queryHandler()
    },
    saveHandler() {
      this.action = 'look'
      this.loading = getLoading4Cxt()
      ImperialUnitsSettingSaveFunc(this.from).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
        this.loading.close()
        syncSpecificBasicData(basicCacheKeys.basic_data_ImperialUnitsSetting)
        this.queryHandler()
      })
    }
  }
}
</script>

